// Utility to preserve tenant context across loginAs flows.

export type PreLoginAsTenantState = {
  activeTenantId: string | null;
  activeTenant: string | null;
  availableTenants: string | null;
  activeTheme: string | null;
};
export function savePreLoginAsTenantState(): void {
  const savedTenantContext = {
    activeTenantId: localStorage.getItem("activeTenantId"),
    activeTenant: localStorage.getItem("activeTenant"),
    availableTenants: localStorage.getItem("availableTenants"),
    activeTheme: localStorage.getItem("activeTheme"),
  };

  localStorage.setItem("preLoginAsTenantContext", JSON.stringify(savedTenantContext));
}

export function restorePreLoginAsTenantState(): {
  activeTenantId?: string | null;
} | null {
  try {
    const saved = localStorage.getItem("preLoginAsTenantContext");
    if (!saved) return null;

    const tenantContext = JSON.parse(saved);

    if (tenantContext?.activeTenantId) {
      localStorage.setItem("activeTenantId", tenantContext.activeTenantId);
    } else {
      localStorage.removeItem("activeTenantId");
    }

    if (tenantContext?.activeTenant) {
      localStorage.setItem("activeTenant", tenantContext.activeTenant);
    } else {
      localStorage.removeItem("activeTenant");
    }

    if (tenantContext?.availableTenants) {
      localStorage.setItem("availableTenants", tenantContext.availableTenants);
    } else {
      localStorage.removeItem("availableTenants");
    }

    if (tenantContext?.activeTheme) {
      localStorage.setItem("activeTheme", tenantContext.activeTheme);
    } else {
      localStorage.removeItem("activeTheme");
    }

    localStorage.removeItem("preLoginAsTenantContext");
    localStorage.removeItem("tenantSelectionRequired");

    return tenantContext;
  } catch (e) {
    console.warn("Failed to restore pre-loginAs tenant context", e);
    localStorage.removeItem("preLoginAsTenantContext");
    return null;
  }
}